module.exports = __webpack_public_path__ + "img/logo-kiwen.c6d8ee93.png";